import { createGlassHttp } from "@crystal/glass-bridge";
import { FrontendName } from "../monitoring.js";
import { AccountType, LockedStatus, LoginOption } from "./email-detection-types.js";
const accountTypeMap = {
  [AccountType.NotRegistered]: AccountType.NotRegistered,
  [AccountType.Full]: AccountType.Full,
  [AccountType.Light]: AccountType.Light,
  [AccountType.Locked]: AccountType.Locked
};
const statusMap = {
  [LockedStatus.Locked]: LockedStatus.Locked,
  [LockedStatus.LockedRuntastic]: LockedStatus.LockedRuntastic
};
const loginOptionMap = {
  [LoginOption.Password]: LoginOption.Password,
  [LoginOption.Social]: LoginOption.Social
};
async function getAccountType(email) {
  const { post } = createGlassHttp({
    clientTag: FrontendName
  });
  try {
    const body = { email };
    const res = await post("/api/account/profile/auth-options", body);
    let accountType = AccountType.NotRegistered;
    let status = void 0;
    const loginOptions = res.loginOptions && res.loginOptions.map((option) => loginOptionMap[option]);
    if (res.accountType) {
      accountType = accountTypeMap[res.accountType];
    }
    if (res.status) {
      accountType = AccountType.Locked;
      status = statusMap[res.status];
    }
    return {
      accountType,
      status,
      loginOptions
    };
  } catch (err) {
    return Promise.reject(err);
  }
}
export {
  getAccountType
};
//# sourceMappingURL=email-detection.js.map
